import { FC, MouseEvent, useEffect, useRef, useState } from "react";
import styles from "./SamuiMapWithBeaches.module.scss";
import { SamuiMap } from "../../icons";
import cl from "classnames";
import { useTranslation } from "next-i18next";
import { useCatalogFilter } from "@/lib/hooks/useCatalogFilter";
import { CatalogCheckboxBlock } from "../../blocks/page-specific/Catalog/CatalogFilter/CatalogCheckboxBlock";

const beaches = [
  {
    title: "HUA_THANON",
    pos: {
      left: "270px",
      top: "403px",
    },
  },
  {
    title: "THONG_KRUT",
    pos: {
      left: "84px",
      top: "450px",
    },
  },
  {
    title: "THONGSON",
    pos: {
      left: "365px",
      top: "60px",
    },
  },
  {
    title: "TALING_NGAM",
    pos: {
      left: "15px",
      top: "370px",
    },
  },
  {
    title: "NATHON",
    pos: {
      left: "40px",
      top: "205px",
    },
  },
  {
    title: "CORAL_COVE",
    pos: {
      left: "350px",
      top: "273px",
    },
  },
  {
    title: "BAAN_THAI",
    pos: {
      left: "135px",
      top: "68px",
    },
  },
  {
    title: "CRYSTAL_BAY",
    pos: {
      left: "355px",
      top: "300px",
    },
  },
  {
    title: "BANG_PO",
    pos: {
      left: "85px",
      top: "85px",
    },
  },
  {
    title: "BANG_KAO",
    pos: {
      left: "175px",
      top: "450px",
    },
  },
  {
    title: "BANGRAK",
    pos: {
      left: "306px",
      top: "109px",
    },
  },
  {
    title: "BOPHUT",
    pos: {
      left: "265px",
      top: "120px",
    },
  },
  {
    title: "MAENAM",
    pos: {
      left: "193px",
      top: "95px",
    },
  },
  {
    title: "CHAWENG",
    pos: {
      left: "342px",
      top: "218px",
    },
  },
  {
    title: "CHOENG_MON",
    pos: {
      left: "395px",
      top: "100px",
    },
  },
  {
    title: "LAMAI",
    pos: {
      left: "315px",
      top: "352px",
    },
  },
];

export const SamuiMapWithBeaches: FC<{ isShow?: boolean }> = ({ isShow }) => {
  const { t } = useTranslation("index");
  const { query } = useCatalogFilter();
  const mapRef = useRef<HTMLDivElement>(null);
  const [ids, setIds] = useState<{ id: string; isDisabled: boolean }[]>([]);
  useEffect(() => {
    if (mapRef.current) {
      const foundIds = mapRef.current.querySelectorAll("path[id]");

      setIds(
        Array.from(foundIds).map((item) => ({
          id: item.id,
          isDisabled: (document.querySelector(`input[id=${item.id}]`) as HTMLInputElement)
            ?.disabled,
        })),
      );
    }
  }, []);

  const selectedIds = (
    typeof query.samuiDistrict === "string" ? [query.samuiDistrict] : query.samuiDistrict
  ) as string[];

  return (
    <div
      ref={mapRef}
      className={styles.map}
      onClick={(e: MouseEvent<HTMLDivElement>) => {
        if (!("id" in e.target)) return;
        const id = e.target.id as string;
        const checkbox = e.currentTarget?.querySelector(
          `input[id='${id}']`,
        ) as HTMLInputElement;
        if (checkbox) {
          checkbox.click();
          checkbox.blur();
        }
      }}
    >
      <SamuiMap
        className={cl(styles.map__samui, isShow && styles['map__samui--show'])}
        id="SamuiFilterMap"
        selectedIds={selectedIds}
        t={t}
        shouldHighlight
      />
      {ids.length > 0 && (
        <CatalogCheckboxBlock
          catalogQuery="samuiDistrict"
          isHidden
          items={ids.map((id) => ({
            value: id.id,
            label: id.id,
            id: id.id,
            isDisabled: id.isDisabled,
          }))}
        />
      )}
    </div>
  );
};
